import React from 'react';
import { css } from '@emotion/react';
import { CircularProgress } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { ResidentListStatus as FetchStatus } from '@/hooks/useResidentList';

const Container = css`
  display: flex;
  align-items: center;
  justify-content: center;
  height: 100px;
  font-size: 16px;
`;

export const ResidentListStatus: React.FC<{ status: FetchStatus }> = ({ status }) => {
  const { t } = useTranslation();
  return (
    <div css={Container}>
      {status === 'loading' ? <CircularProgress /> : status === 'error'
        ? t('@failedToLoadResidents', '利用者一覧を取得できませんでした')
        : t('thereAreNoResidents', '入居者がいません')}
    </div>
  );
};
